var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal modal-filter-details fade",
      attrs: {
        id: "replace-talent",
        role: "dialog",
        "aria-labelledby": "location-label",
        "aria-hidden": "true",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _c("div", { staticClass: "form-horizontal" }, [
              _c(
                "div",
                { class: _vm.$hasErrorClass(_vm.$v.talent, "form-group") },
                [
                  _c("label", { staticClass: "control-label col-sm-4" }, [
                    _vm._v("Replace"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-sm-8" },
                    [
                      _c("selectize", {
                        staticClass: "selectize selectize-single form-control",
                        attrs: {
                          name: "attending_talent",
                          options: _vm.attendingTalentOptions,
                        },
                        model: {
                          value: _vm.$v.talent.$model,
                          callback: function ($$v) {
                            _vm.$set(_vm.$v.talent, "$model", $$v)
                          },
                          expression: "$v.talent.$model",
                        },
                      }),
                      _vm._v(" "),
                      _c("vuelidate-help", {
                        attrs: {
                          label: "Attending talent",
                          field: _vm.$v.talent,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { class: _vm.$hasErrorClass(_vm.$v.replacement, "form-group") },
                [
                  _c("label", { staticClass: "control-label col-sm-4" }, [
                    _vm._v("With"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-sm-8" },
                    [
                      _c("selectize", {
                        staticClass: "selectize selectize-single form-control",
                        attrs: {
                          name: "replacement_talent",
                          options: _vm.initialReplacementTalentOptions,
                          score: _vm.replacementScoringCallback,
                          "fetch-results":
                            _vm.handleFetchReplacementTalentCallback,
                        },
                        model: {
                          value: _vm.$v.replacement.$model,
                          callback: function ($$v) {
                            _vm.$set(_vm.$v.replacement, "$model", $$v)
                          },
                          expression: "$v.replacement.$model",
                        },
                      }),
                      _vm._v(" "),
                      _c("vuelidate-help", {
                        attrs: {
                          label: "Replacement talent",
                          field: _vm.$v.replacement,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-footer" },
            [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "ladda-button",
                {
                  staticClass: "btn btn-lg btn-primary",
                  attrs: {
                    type: "button",
                    click: _vm.handleSaveReplacedTalentCallback,
                  },
                },
                [
                  _c("i", { staticClass: "fa fa-check" }),
                  _vm._v(" Save\n        "),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "h4",
        { staticClass: "modal-title", attrs: { id: "location-label" } },
        [_vm._v("Replace Booked Talent")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "btn btn-lg btn-danger pull-left",
        attrs: { type: "button", "data-dismiss": "modal" },
      },
      [_c("i", { staticClass: "fa fa-close" }), _vm._v(" Cancel")]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }